// extracted by mini-css-extract-plugin
module.exports = {"link":"menuItem-module--link--cHUXk","item":"menuItem-module--item--1hRwJ","hide":"menuItem-module--hide--15_m2","active":"menuItem-module--active--1yy6w"};